<app-modal-container cardBodyClass="px-4 py-2">
  <div class="modal-header-content">
    {{ 'migrate_workspace' | translate }}
  </div>
  <div class="modal-body-content migrate-workspace-modal-content">
    <div class="margin-bottom-md text-black">
      {{ 'migrate_workspace_text' | translate }}
    </div>
    <div class="pagination-entries">
      <form [formGroup]="form" class="w-100">
        <app-searchbox
          class="w-100"
          [placeholder]="'search_by_workspace_name' | translate"
          [formControlName]="$workspace.name"
        ></app-searchbox>
      </form>
    </div>
    <div class="pagination-entries justify-content-between d-flex flex-wrap">
      <div class="margin-right-md fw-bold text-black col-auto">
        {{ 'migrate_workspace_number_selected' | translate: [selectedWorkspacesCount] }}
      </div>
      <div class="col-auto">
        <app-responsive-pagination
          [page]="page$ | async"
          [pageSize]="pageSize$ | async"
          [collectionSize]="totalRows$ | async"
          [entryLimits]="pageSizes"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
        ></app-responsive-pagination>
      </div>
    </div>
    <div class="divider"></div>
    @if (tableData$ | async; as tableData) {
      <div class="row">
        <div class="col-12">
          <app-ngb-table [config]="tableConfig" [data]="tableData"> </app-ngb-table>
        </div>
      </div>
    }
  </div>
  <div class="modal-footer-content">
    <div class="row justify-content-between">
      <div class="col-auto">
        <button class="btn btn-outline-primary font-weight-500" (click)="onClose()">
          {{ 'label_close' | translate }}
        </button>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary font-weight-500" [disabled]="selectedWorkspacesCount === 0" (click)="migrateWorkspace()">
          {{ 'migrate_workspace' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal-container>
